import { useMutation, useQueryClient } from "@tanstack/react-query";
import { InvalidateVisitPdf } from "Services/API/VisitPdf.service";

export const useNotePdfInvalidate = (visitId, patientId) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    // Accepts either a bare pdfId (the original call style, still used by the row
    // action) or { pdfId, reason } from the edit modal.
    mutationFn: (arg) => {
      const { pdfId, reason } = typeof arg === "string" ? { pdfId: arg } : arg || {};
      return InvalidateVisitPdf(pdfId, reason);
    },
    onSuccess: () => {
      // Both lists render the same rows from different query keys. Only the per-visit
      // one used to be refreshed, so invalidating from the patient-wide Notes tab left
      // that tab showing the note as still valid until a manual reload.
      queryClient.invalidateQueries(["visitPdfs", visitId, patientId]);
      queryClient.invalidateQueries(["patientPdfs", patientId]);
      // The freed days change the remaining budget.
      queryClient.invalidateQueries(["noteDayUsage", patientId]);
    },
  });

  return {
    invalidatePdf: mutation.mutate,
    isLoading: mutation.isLoading,
    error: mutation.error,
    reset: mutation.reset,
  };
};
